module.exports = __webpack_public_path__ + "static/img/03.6fcff485.png";